import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import PostAddIcon from '@mui/icons-material/PostAdd';
import GoatMascot from './GoatMascot';

/** Shown when the feed has no more pages — nudges the user to contribute. */
const EndOfFeed: FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ textAlign: 'center', py: 4, px: 2 }}>
      {/* The goat dozes off once there's nothing left to graze. */}
      <Box sx={{ mb: 1 }}>
        <GoatMascot variant="sleep" size={56} />
      </Box>
      {/* Guide .eyebrow: mono uppercase micro-label between hairline rules */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.75, mb: 2 }}>
        <Box sx={{ flex: 1, height: '1px', backgroundColor: 'var(--g-line)' }} />
        <Typography
          component="span"
          sx={{
            fontFamily: (t) => t.tokens.typography.monoFontFamily,
            fontSize: '10.5px',
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            color: 'var(--color-text-4)',
          }}
        >
          End of feed
        </Typography>
        <Box sx={{ flex: 1, height: '1px', backgroundColor: 'var(--g-line)' }} />
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        You're all caught up — maybe post something?
      </Typography>
      <Button
        variant="contained"
        color="secondary"
        startIcon={<PostAddIcon />}
        onClick={() => navigate('/submit')}
      >
        Create Post
      </Button>
    </Box>
  );
};

export default EndOfFeed;
